import React from "react";
import ReactAvatar from "react-avatar";
import ColorHash from "color-hash";

const Avatar = ({ name, size, selectable, onSelect }) => {
	const colorHash = new ColorHash({ lightness: [0.4, 0.4, 0.4] });
	const backgroundColor = colorHash.hex(name);

	let props = {
		size,
		name,
		color: backgroundColor,
		fgColor: "#ffffff",
		round: true
	};

	if (selectable) {
		props.onClick = onSelect;
		props.style = {
			cursor: "pointer"
		};
	}

	return (
		<ReactAvatar {...props} />
	);
};

export default Avatar;